import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";
import { ICenter } from "../../../../../.MODULS/BOOKLET_ADMIN_MODUL/Master/Center/ICenter";

export const CentreMasterCreateSlice = createSlice({
  name: "CentreMasterCreateSlice",
  initialState: {} as IReduxState<ICenter>,
  reducers: {
    centreMasterCreate: (state, _: PayloadAction<ICenter>) => {
      state.isLoading = true;
    },
    successCentreMasterCreate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureCentreMasterCreate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearCentreMasterCreate: (state) => {
      state.data = {};
    },
  },
});

export const {
  centreMasterCreate,
  failureCentreMasterCreate,
  successCentreMasterCreate,
  clearCentreMasterCreate,
} = CentreMasterCreateSlice.actions;

export default CentreMasterCreateSlice.reducer;
